export const initial = [
  {
    price: "149",
    per: "",
    subHeading: "1-50 Reports",
    modal_heading: "Cost Per Report (USD)",
    modal_subheading: "Excludes Taxes and Duties",
    list: ["No software or deployment required", "Easy rater management"],
    active_list: [
      "1-50 Reports",
      "No software or deployment required",
      "Easy rater management",
      "Seamless survey",
      "Assign weightage to competencies",
      "Manage proficiency levels",
      "Set benchmarks",
      "Feedback report",
      "Individual development plan",
      "Alert system for highlighting indicators impacting succession and development strategy",
      "Interactive dashboard",
      "Complimentary sharing of our annual insights based on industry and region",
    ],
  },
];
export const mid = [
  {
    price: "175",
    per: "",
    subHeading: "51-100 Reports",
    modal_heading: "Cost Per Report (USD)",
    modal_subheading: "Excludes Taxes and Duties",
    list: [
      "Machine enabled learning",
      "Engagement enabler on scores and feedback",
    ],
    active_list: [
      "51-100 Reports",
      "No software or deployment required",
      "Easy rater management",
      "Seamless survey",
      "Assign weightage to competencies",
      "Manage proficiency levels",
      "Set benchmarks",
      "Feedback report",
      "Individual development plan",
      "Alert system for highlighting indicators impacting succession and development strategy",
      "Interactive dashboard",
      "Complimentary sharing of our annual insights based on industry and region",
      "Machine enabled learning",
      "Engagement enabler on scores and feedback",
    ],
  },
];
export const popular = [
  {
    price: "199",
    per: "",
    subHeading: "100+ Reports",
    modal_heading: "Cost Per Report (USD)",
    modal_subheading: "Excludes Taxes and Duties",
    list: ["Coaching integration enabled", "Advanced analytics"],
    active_list: [
      "No software or deployment required",
      "100+ Reports",
      "Easy rater management",
      "Seamless survey",
      "Assign weightage to competencies",
      "Manage proficiency levels",
      "Set benchmarks",
      "Feedback report",
      "Individual development plan",
      "Alert system for highlighting indicators impacting succession and development strategy",
      "Interactive dashboard",
      "Complimentary sharing of our annual insights based on industry and region",
      "Machine enabled learning",
      "Engagement enabler on scores and feedback",
      "Coaching integration enabled",
      "Advanced analytics",
    ],
  },
];

export const custom = [
  {
    price: "180",
    per: "",
    subHeading: "Unlimited reports",
    modal_heading: "Annual Cost Per Employee (USD)",
    modal_subheading: "Excludes Taxes and Duties",
    list: [
      "Import your own competency model / catalogue",
      "Use 36Tens Technology platform for advanced reporting and features",
    ],
    active_list: [
      "Import your own competency model / catalogue",
      "Use 36Tens Technology platform for advanced reporting and features",
      "Unlimited reports",
      "No software or deployment required",
      "Easy rater management",
      "Seamless survey ",
      "Assign weightage to competencies",
      "Manage proficiency levels",
      "Set benchmarks",
      "Feedback report",
      "Integrate your own development action items",
      "Alert system for highlighting indicators impacting succession and development strategy",
      "Interactive dashboard",
      "Complimentary sharing of our annual insights based on industry and region",
      "Machine enabled learning",
      "Engagement enabler on scores and feedback",
      "Coaching integration enabled",
      "Advanced analytics",
      "Annual Access",
    ],
  },
];
